import { EEducationLevel, EStudyForm, EStudyYear } from '@/shared/types';
/**
 * Маппинг образовательных параметров в текст.
 */
export const EDUCATION_LEVEL_TO_TEXT_MAPPER = {
  [EEducationLevel.BasicGeneralEducation]: 'Основное общее образование',
  [EEducationLevel.SecondaryGeneralEducation]: 'Среднее (полное) общее образование',
  [EEducationLevel.SecondaryProfessionalEducation]: 'Среднее профессиональное',
  [EEducationLevel.BachelorEducation]: 'Бакалавриат',
  [EEducationLevel.SpecialistEducation]: 'Специалитет',
  [EEducationLevel.MasterEducation]: 'Магистратура',
  [EEducationLevel.DoctoralEducation]: 'Аспирантура',
  [EEducationLevel.NotEducating]: 'Не учусь',
};

export const STUDY_FORM_TO_TEXT_MAPPER = {
  [EStudyForm.FullTimeStudy]: 'Очная',
  [EStudyForm.PartTimeStudy]: 'Очно-заочная',
  [EStudyForm.RemoteStudy]: 'Заочная',
  [EStudyForm.NotStudying]: 'Не учусь',
};

export const STUDY_YEAR_TO_TEXT_MAPPER = {
  [EStudyYear.FirstCourse]: '1 курс',
  [EStudyYear.SecondCourse]: '2 курс',
  [EStudyYear.ThirdCourse]: '3 курс',
  [EStudyYear.FourthCourse]: '4 курс',
  [EStudyYear.FifthCourse]: '5 курс',
  [EStudyYear.SixthCourse]: '6 курс',
  [EStudyYear.Graduate2026]: 'Выпускник 2026 года',
  [EStudyYear.Graduate2025AndEarlier]: 'Выпускник 2025 года и ранее',
};
